import React, { useMemo } from "react";
import classNames from "classnames";
import { ReactComponent as ChevronArrowSVG } from "@/assets/svgs/icons/chevron_arrow.svg";


interface ChevronArrowIconProps {
    className?: string;
    direction?: "up" | "down" | "left" | "right";
    "aria-hidden"?: boolean | "true" | "false";
}

const ChevronArrowIcon: React.FC<ChevronArrowIconProps> = (props) => {
    const {
        className: propsClassName = "stroke-white size-4.5",
        direction,
        "aria-hidden": ariaHidden = "true"
    } = props;

    const directionClassname = useMemo(() => {
        switch (direction) {
            case "up":
                return "rotate-180";
            case "down":
                return "rotate-0";
            case "left":
                return "rotate-90";
            case "right":
                return "-rotate-90";
            default:
                return "";
        }
    }, [direction]);

    return (
        <ChevronArrowSVG className={classNames(propsClassName, directionClassname)}
                         aria-hidden={ariaHidden}
        />
    );
};

export default ChevronArrowIcon;
